/**
 * The statusline strip from the command centre mock.
 *
 * The mock states four facts flatly, including "System status:
 * operational". This version states only what the app can actually
 * observe: whether the last poll succeeded, and when it last returned.
 * A hardcoded "operational" on a monitoring surface is worse than no
 * line at all, because it reads as a check that ran.
 *
 * live is deliberately THREE-state. It first shipped as
 * `!alerts.error && !summary.error`, which is true before any request
 * has been made, so a Shell with nothing loaded showed a green pip and
 * "Data feed responding" (seen in production, 4 September 2026). That is
 * the same lie as the mock's "operational", just arrived at by
 * accident. null means no answer yet and says so.
 */
export function StatusLine({
  live,
  lastUpdated,
  voiceAvailable,
}: {
  live: boolean | null;
  lastUpdated: Date | null;
  voiceAvailable: boolean;
}) {
  const time = lastUpdated
    ? lastUpdated.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
    : null;
  return (
    <div className="cc-statusline" role="status">
      <span
        className={`cc-live${live === true ? '' : live === false ? ' stale' : ' pending'}`}
        aria-hidden
      />
      <span>
        {live === true
          ? 'Data feed responding'
          : live === false
            ? 'Data feed not responding'
            : 'Waiting for the data feed'}
      </span>
      <span className="sep" aria-hidden>
        |
      </span>
      <span>{time ? `Last updated ${time}` : 'Waiting for first update'}</span>
      <span className="sep" aria-hidden>
        |
      </span>
      <span>
        {voiceAvailable ? 'A.F.R.O.B.O.T voice available' : 'A.F.R.O.B.O.T voice unavailable here'}
      </span>
    </div>
  );
}
